// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar-module--nav--srUbP","list":"Navbar-module--list--22wNO","listItem":"Navbar-module--listItem--2O7GZ","text":"Navbar-module--text--3xxlU"};